module.exports = __webpack_public_path__ + "static/male-1-c0a743a16ef902d9455fac516bf8ca0b.jpeg";